// extracted by mini-css-extract-plugin
export default {"textarea":"textarea_textarea__AVVaL","error":"textarea_error__aZD74"};